import { faTimes } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../baseComponents/TwinIcon'
import { TwinDictionary } from '../../utils/globals/dictionary'
import { useCallback } from 'react'
import { twinFetchPostJSON } from '../../utils/globals/data'

export interface TitleAndDeleteQuoteCostProps extends TitleAndDeleteQuoteCostLogicProps {
    dictCosts: TwinDictionary
}

const TitleAndDeleteQuoteCost: React.FC<TitleAndDeleteQuoteCostProps> = ({ dictCosts, cost, getCompleteData, url }) => {
    const { deleteQuoteCost } = useTitleAndDeleteQuoteCostLogic({ cost, getCompleteData, url })
    return (
        <div className='flex justify-between items-center mb-17'>
            <span className='regular18'>
                {dictCosts?.[cost?.CostId]?.name}
            </span>
            <TwinIcon className='cursor-pointer' icon={faTimes} onClick={deleteQuoteCost} />
        </div>
    )
}
interface TitleAndDeleteQuoteCostLogicProps {
    cost: TwinDictionary
    url: string
    getCompleteData: () => void
}

const useTitleAndDeleteQuoteCostLogic = ({ cost, getCompleteData, url }: TitleAndDeleteQuoteCostLogicProps) => {
    const deleteQuoteCost = useCallback(async () => {
        const result = await twinFetchPostJSON(url, { OrderId: cost?.OrderId, CostId: cost?.CostId })
        if (result) {
            getCompleteData()
        }
    }, [cost, getCompleteData, url])

    return { deleteQuoteCost }
}

export default TitleAndDeleteQuoteCost